import { createRpcClientV2 } from 'rpc-client-utils';
import noPortalApiClient from 'hub-http/clients/noPortalApiClient';
import { reviewAndConfirmDataRpc, IndustryDataPointValueTypename, CompanySizeDataPointValueTypename, StringDataPointValueTypename } from '../../__generated__/chirp/com/hubspot/get/to/know/me/data/rpc/HublessReviewAndConfirmRpc';
import { getSignupDataGtkmData, getSignupDataValue } from '../store/signup-data/selectors';
import { Data } from 'signup-constants/signupData/Data';
import { kebabToScreamingSnake } from '../utils/kebabToScreamingSnake';
import { CompanySizeAttributes } from 'signup-constants/signupData/CompanySizeAttributes';
import { getPortalId } from '../store/auth/selectors';
import { logInAndQuestionsCheck } from '../http/endpointStateChecks';
import { hasGTKMDomainChanged } from '../hooks/useGTKMDomainSubmit';
import { isAssignedToGTKMExperiment } from '../utils/gtkm/isAssignedToGTKM';
export const shouldSendGTKMReviewAndConfirmRequest = state => {
  const isAssignedToGTKM = isAssignedToGTKMExperiment(state);
  return logInAndQuestionsCheck(state) && isAssignedToGTKM;
};
const getTransformedCorrectedData = (dataPoint, signupData) => {
  switch (dataPoint) {
    case Data.Industry:
      return {
        value: kebabToScreamingSnake(signupData),
        __typename: IndustryDataPointValueTypename
      };
    case Data.CompanySize:
      return {
        value: CompanySizeAttributes[signupData].companySizeScreamingSnake,
        __typename: CompanySizeDataPointValueTypename
      };
    default:
      return {
        value: signupData,
        __typename: StringDataPointValueTypename
      };
  }
};
export const getCorrectedConfirmedDataPoints = state => {
  const dataPoints = [Data.CompanySize, Data.Industry, Data.CompanyName];
  const correctedDataPoints = {};
  const confirmedDataPoints = [];
  const hasDomainChanged = hasGTKMDomainChanged(state);
  dataPoints.forEach(dataPoint => {
    const gtkmData = getSignupDataGtkmData(state, dataPoint);
    const signupData = getSignupDataValue(state, dataPoint);
    if (signupData && gtkmData === signupData && !hasDomainChanged) {
      confirmedDataPoints.push(dataPoint);
    } else {
      correctedDataPoints[dataPoint] = getTransformedCorrectedData(dataPoint, signupData);
    }
  });
  return {
    correctedDataPoints,
    confirmedDataPoints
  };
};
export const HublessReviewAndConfirmClient = requestData => {
  const rpcClient = createRpcClientV2({
    hubHttpClient: noPortalApiClient
  });
  return rpcClient.call(reviewAndConfirmDataRpc, {
    request: requestData,
    timeout: 8000
  });
};
export const HublessReviewAndConfirm = state => {
  const domain = getSignupDataValue(state, Data.CompanyDomain);
  const {
    correctedDataPoints,
    confirmedDataPoints
  } = getCorrectedConfirmedDataPoints(state);
  return HublessReviewAndConfirmClient({
    portalId: getPortalId(state) || 0,
    domain,
    correctedDataPoints,
    confirmedDataPoints
  });
};